<template>
  <transition name="el-fade-in-linear">

	  <div class="cz-login-main">
          <!-- 背景图 -->
          <img src="../assets/login_icon_v4.0/backimg.png" class="cz-login-main-backimg"/>

          <!-- logo -->
          <div class="cz-login-main-login-logo">
              <img src="../assets/login_icon_v4.0/logo.png" />
          </div>

          <!-- 登录页 -->
          <div class="cz-login-main-login-infos">
              <div class="cz-login-main-login">
                  <div class="cz-login-main-icon-1"></div>
                  <div class="cz-login-main-icon-2"></div>
                  <div class="cz-login-main-icon-3"></div>
                  <div class="cz-login-main-icon-4"></div>

                  <!-- 选择头像 -->
                  <div class="cz-login-main-avage" v-if="showmanagers==false">
                      <el-tooltip class="item" effect="dark" content="点击可切换登录账号" placement="top">
                      <div class="cz-login-main-avage-infos"  @click="showorcloseavage('')">
                          <div class="cz-login-main-avage-infos-in cz-login-sum"><img :src="login.thumb!='' ? login.thumb : require('../assets/login_icon_v4.0/default_logo.png')" /></div>
                      </div>
                      </el-tooltip>
                  </div>

                  <!-- 可选头像列表 -->
                  <div class="cz-login-main-avage" v-if="showmanagers">
                      <div class="cz-login-main-avage-infos" v-for="(item,index) in managerlists" :key="index" @click="showorcloseavage(item)">
                          <div class="cz-login-main-avage-infos-in"><img :src="item.thumb!='' ? item.thumb : require('../assets/login_icon_v4.0/default_logo.png')" /></div>
                      </div>
                  </div>

                  <!-- 代理商信息 -->
                  <div class="cz-login-agent-truename" v-if="login.agentname!='' && login.truename!=''">{{login.agentname}} - {{login.truename}}</div>

                  <div :class="login.agentname!='' && login.truename!='' ? 'cz-login-main-inputs cz-input-top-first' : 'cz-login-main-inputs' ">
                      <i class="cz-login-main-inputs-left cz-login-username"></i>
                      <div class="cz-login-main-inputs-right">
                          <el-input type="text" v-model="login.phone" placeholder="请输入登录账号" clearable/>
                      </div>
                  </div>
                  <div class="cz-login-main-inputs">
                      <i class="cz-login-main-inputs-left cz-login-password"></i>
                      <div class="cz-login-main-inputs-right">
                          <el-input type="password" v-model="login.password" placeholder="请输入登录密码" clearable/>
                      </div>
                  </div>
                  <div class="cz-login-main-select">
                      <el-checkbox v-model="login.record">记住密码</el-checkbox>
                  </div>
                  <div class="cz-login-main-submit">
                      <el-button size="small" :loading="loading" @click="logins">登 录</el-button>
                  </div>
                  

              </div>
          </div>
      </div>

  </transition>
</template>

<script>
export default {
  data () {
    return {
      url:this.GLOBAL.domain+'login/index',
      backimg: '',
      login:{
        act:'login',
        phone:'',
        password:'',
        thumb:'',
        agentname:'',
        truename:'',
        record:false,
      },
      time:'',
      transitionshow:true,
      showmanagers:false,
      managerlists:[],
      showthumbs:'',
      loading:false,

    }
  },
  
  mounted(){
      this.getrecord();  //检测当前用户是否已登录
      
  },
  
  methods:{

      //logins登录
      logins() {
          this.loading=true;
          var resource=this.$resource(this.url);
      	  resource.save(this.login).then((res)=>{
	          if(res.data.Result > 0){
	          	this.$message.error(res.data.Message);
                this.loading=false;
	          }else{
		            var data=JSON.parse(Base64.decode(res.data.Data));
                this.$cookies.set('agentid',data.agentid);
		            this.$cookies.set('token',data.token);
                localStorage.setItem('token',data.token);
                this.$cookies.set('managerid',data.id);
                this.$cookies.set('truename',data.truename);
                this.$cookies.set('agentname',data.agentname);
                this.$cookies.set('cityname',data.cityname);
		            this.$cookies.set('groupid',data.role_id);
                this.$cookies.set('datacenter',data.datacenter);
                this.$cookies.set('wangdian_sid', data.wangdian_sid)
                this.$cookies.set('wangdian_state', data.wangdian_state)
                this.$cookies.set('is_finance_white', data.is_finance_white)
                console.log(data, 'login')
                var thumb=data.thumb=='' || data.thumb==null ? '' : this.GLOBAL.staticUrl+data.thumb;
	          
		            //如果用户勾选了记录密码则记录用户名、登录密码进cookies
		            if(this.login.record) {
                    this.$cookies.set('phone',this.login.phone,604800);
                    this.$cookies.set('password',this.login.password,604800);
                    this.$cookies.set('thumb',thumb,604800);
                    this.$cookies.set('agentname',data.agentname,604800);
                    this.$cookies.set('truename',data.truename,604800);
                    this.$cookies.set('record',1,604800);
		            }else {
                    this.$cookies.set('phone',this.login.phone,604800);
		         	      this.$cookies.set('password','');
		         	      this.$cookies.set('record',0);
                    this.$cookies.set('thumb',thumb,604800);
                    this.$cookies.set('agentname',data.agentname,604800);
                    this.$cookies.set('truename',data.truename,604800);
                }

                //重新将登录管理员信息保存到cookie里（去除最后一个）
                let _this=this;
                var memorys=[];
                memorys.push({phone:this.login.phone,
                              password:this.login.record ? this.login.password : '',
                              record:this.login.record ? 1 : 0,
                              thumb:thumb=='' ? '' : thumb,
                              agentname:data.agentname,
                              truename:data.truename
                            });
                this.managerlists.forEach(function(e,i) {
                    if(memorys.length < 3 && e.phone!=_this.login.phone) memorys.push({phone:e.phone,password:e.password,record:e.record,thumb:e.thumb,agentname:e.agentname,truename:e.truename});
                });
                var memoryname=this.GLOBAL.domain+'managermemorys';
                this.$cookies.set(memoryname,JSON.stringify(memorys),604800);
                this.loading=false;
	          	  this.$router.push('/menu');
	          }
          }).catch((res) => {
          	  this.loading=false;
          });

      },

      //检测当前账号是否已登录
      getrecord() {
          //获取存在cookie里的最近登录管理员信息（最多存5个）
          var memoryname=this.GLOBAL.domain+'managermemorys';
          var mlinfolists=this.$cookies.get(memoryname);
          mlinfolists=JSON.parse(mlinfolists);
          this.managerlists=mlinfolists ? mlinfolists : [];

          //获取第一个登录的管理员账号信息
          var logininfos=this.managerlists ? this.managerlists[0] : {};
          this.login.phone=logininfos ? logininfos.phone : '';
          this.login.password=logininfos ? logininfos.password : '';
          this.login.thumb=logininfos ? logininfos.thumb : '';
          this.login.agentname=logininfos ? logininfos.agentname : '';
          this.login.truename=logininfos ? logininfos.truename : '';
          this.login.record=logininfos && logininfos.record==1 ? true : false;
      },


      //展开、关闭选择头像
      showorcloseavage(item) {
          if(this.managerlists.length <= 1) return false;
          if(this.showmanagers) {
              this.login.phone=item.phone;
              this.login.password=item.password;
              this.login.record=item.record==1 ? true : false;
              this.login.thumb=item.thumb ? item.thumb : '';
              this.login.agentname=item.agentname ? item.agentname : '';
              this.login.truename=item.truename ? item.truename : '';
          }


          this.showmanagers ? this.showmanagers=false : this.showmanagers=true;
      },

  }

}
</script>

<style>
.cz-login-main {position:absolute;overflow:hidden;width:100%;height:100%;background:url(../assets/login_icon_v4.0/back_base.png) no-repeat;background-size:100% 100%;}
.cz-login-main img {height:100%;}
.cz-login-main-login-logo {position:absolute;width:100%;height:50px;top:10px;left:0;background:rgba(221,221,221,0);}
.cz-login-main-login-logo img {float:left;height:50px;margin-left:3%;transition:.3s all;}
.cz-login-main-content {float:left;height:50px;width:40%;margin-left:10px;display:flex;justify-content:center;align-items:center;transition:.3s all;}
.cz-login-main-in {float:left;width:100%}
.cz-login-main-in span {float:left;width:100%;font-size:14px;line-height:18px;color:#fff;font-weight:100;}
.cz-login-name {letter-spacing:7px;}
.cz-login-web {font-size:12px !important;letter-spacing:2px;}

.cz-login-main-login-infos {position:absolute;width:400px;height:100%;right:5%;top:0;display:flex;justify-content:center;align-items:center;}
.cz-login-main-login {width:calc(90% - 80px);padding:40px;background:rgba(11,79,165,.3);border-radius:6px;border:2px solid #0B4FA5;position:relative;transition:1s all;}
.cz-login-main-icon-1,.cz-login-main-icon-2,.cz-login-main-icon-3,.cz-login-main-icon-4 {width:20px;height:20px;}
.cz-login-main-icon-1 {position:absolute;top:-2px;left:-2px;border-top:3px solid #31A1FD;border-left:3px solid #31A1FD;border-radius:6px 0 0 0;}
.cz-login-main-icon-2 {position:absolute;top:-2px;right:-2px;border-top:3px solid #31A1FD;border-right:3px solid #31A1FD;border-radius:0 6px 0 0;}
.cz-login-main-icon-3 {position:absolute;bottom:-2px;left:-2px;border-bottom:3px solid #31A1FD;border-left:3px solid #31A1FD;border-radius:0 0 0 6px;}
.cz-login-main-icon-4 {position:absolute;bottom:-2px;right:-2px;border-bottom:3px solid #31A1FD;border-right:3px solid #31A1FD;border-radius:0 0 6px 0;}

.cz-login-main-avage {display:flex;justify-content:center;align-items:center;width:100%;height:60px;margin-top:20px;}
.cz-login-main-avage-infos {width:25%;height:60px;display:flex;justify-content:center;align-items:center;cursor:pointer;}
.cz-login-main-avage-infos-in {width:48px;height:48px;border-radius:50%;border:2px solid #dddddd;background:#fff;overflow:hidden;}
.cz-login-main-avage-infos-in img {float:left;width:100%;transition:.3 all;-webkit-animation-timing-function:ease-in-out;-webkit-animation-name:none;-webkit-animation-duration:600ms;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;}
.cz-login-main-avage-infos-in img:hover {-webkit-animation-name:doudong;}

.cz-login-sum {transition:1 all;-webkit-animation-timing-function:ease-in-out;-webkit-animation-name:mysum;-webkit-animation-duration:1500ms;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;}

.cz-login-agent-truename {display:inline-block;width:100%;text-align:center;font-size:14px;line-height:21px;margin:20px 0 0 0;font-weight:200;color:#2278c4;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}

.cz-login-main-inputs {display:inline-block;width:calc(100% - 4px);height:40px;margin-top:15px;border-radius:6px;border:2px solid #2788de;font-size:0;}
.cz-input-top-first {margin-top:30px}
.cz-login-main-inputs-left {float:left;width:40px;height:40px;margin-left:2%}
.cz-login-main-inputs-right {float:left;width:calc(100% - 40px - 2%);height:40px;}
.cz-login-username {background:url(../assets/login_icon_v4.0/username_icon.png) no-repeat; background-size:22px 22px;background-position:center center;}
.cz-login-password {background:url(../assets/login_icon_v4.0/password_icon.png) no-repeat; background-size:22px 22px;background-position:center center;}
.cz-login-main-select {display:flex;align-items:center;width:100%;height:30px;margin-top:5px;}
.cz-login-main-select .el-checkbox__inner {border:1px solid #2788de;background-color:none;background:none;}
.cz-login-main-select .el-checkbox {color:#2788de;}
.cz-login-main-select .el-checkbox__input.is-checked .el-checkbox__inner, 
.cz-login-main-select .el-checkbox__input.is-indeterminate .el-checkbox__inner {border-color:#2788de;background-color:none !important;background:none !important;}

.cz-login-main-submit {display:inline-block;width:100%;height:40px;margin-top:20px;border-radius:6px;overflow:hidden;}
.cz-login-main-submit .el-button--mini, .cz-login-main-submit .el-button--small, .cz-login-main-submit .el-button--medium {width:100%;height:40px;border-radius:6px;border-color:#3881f9;}
.cz-login-main-submit .el-button {background:#31A1FD;color:#fff;font-size:14px;}
.cz-login-main-submit .el-button:focus, .cz-login-main-submit .el-button:hover {color:#fff;background-color:#31A1FD;border-color:#31A1FD;}


.cz-login-main-inputs-right .el-input__inner{background:none;border:none;padding:0 15px 0 5px;font-weight:400;border-radius:0;color:#2788de;}
.cz-login-main-inputs-right .el-input__inner:hover {background:none;border:none;box-shadow:none;}
.cz-login-main-inputs-right .el-input__inner::-webkit-input-placeholder{color:#285caf}


@-webkit-keyframes doudong {
   0% {
	    transform:rotate(55deg);
   }
   25% {
	    transform:rotate(0deg);
   }
   50% {
	    transform:rotate(55deg);
   }
   75% {
	    transform:rotate(0deg);
   }
   100% {
	    transform:rotate(55deg);
   }
}

@-webkit-keyframes mysum {
   0% {
	    box-shadow:0 0 0 #ffd100; 
   }
   100% {
	    box-shadow:0 0 25px #ffd100; 
   }
}



/*当屏幕大于0px小于500px（手机竖屏）*/
@media screen and (min-width:0px) and (max-width:500px){
	  .cz-login-main-backimg {opacity:0}
    .cz-login-main-content {width:0;overflow:hidden;}
    .cz-login-main-login-infos {width:90%;}
    .cz-login-main-login-logo {opacity:1}
}

/*当屏幕大于500px小于960px（手机横屏）*/
@media screen and (min-width:500px) and (max-width:960px){
    .cz-login-main-backimg {opacity:0}
    .cz-login-main-content {width:0;overflow:hidden;}
    .cz-login-main-login-infos {width:90%;}
    .cz-login-main-login-logo {opacity:0}
}


/*当屏幕大于960px（PC尺寸）*/
@media screen and (min-width:960px){
    .cz-login-main-backimg {opacity:1}
    .cz-login-main-content {width:40%;overflow:hidden;}
    .cz-login-main-login-infos {width:400px;}
    .cz-login-main-login-logo {opacity:1}
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue